import React from "react";
import { useTranslation } from "react-i18next";



const StoresTable = (props) => {
  const { t } = useTranslation();

  return (
    <div className="table-wrapper px-3 pt-3">
      <div className="d-flex flex-wrap">
        <p className="table-type">{t("admin.stores.table.allStores")}</p>

      </div>
      <div className="table-wrapper-scroll-y table-scrollbar">
        <div className="table-own table-responsive">
          <table className="table table-striped table-hover table-admin">
            <thead className="table-head">
              <tr>
                <th
                  className={`sort-header cursor ${props?.sortObj?.sortVal === "storeName" ? "active" : ""
                    } ${props?.sortObj?.sortType ? "aesc" : "desc"}`}
                  onClick={() => props.arraySorting("storeName")}
                >
                  <span>{t("admin.stores.table.storeName")}</span>{" "}
                  {props?.sortObj?.sortType === "aesc" && (
                    <i className="fas fa-caret-down"></i>
                  )}
                  {props?.sortObj?.sortType === "desc" && (
                    <i className="fas fa-caret-up"></i>
                  )}
                </th>
                <th
                  className={`sort-header cursor ${props?.sortObj?.sortVal === "searchAddress" ? "active" : ""
                    } ${props?.sortObj?.sortType ? "aesc" : "desc"}`}
                  onClick={() => props.arraySorting("searchAddress")}
                >
                  <span>{t("admin.stores.table.address")}</span>{" "}
                  {props?.sortObj?.sortType === "aesc" && (
                    <i className="fas fa-caret-down"></i>
                  )}
                  {props?.sortObj?.sortType === "desc" && (
                    <i className="fas fa-caret-up"></i>
                  )}
                </th>
                <th>
                  <span>{t("admin.stores.table.zone")}</span>
                </th>
                <th
                  className={`sort-header cursor ${props?.sortObj?.sortVal === "stockQuantity" ? "active" : ""
                    } ${props?.sortObj?.sortType ? "aesc" : "desc"}`}
                  onClick={() => props.arraySorting("stockQuantity")}
                >
                  <span>{t("admin.stores.table.stockQuantity")}</span>{" "}
                  {props?.sortObj?.sortType === "aesc" && (
                    <i className="fas fa-caret-down"></i>
                  )}
                  {props?.sortObj?.sortType === "desc" && (
                    <i className="fas fa-caret-up"></i>
                  )}
                </th>
                <th>
                  <span>{t("admin.stores.table.lastActivity")}</span>
                </th>
                <th className="text-center">
                  <span>{t("admin.stores.table.hiddenOnMap")}</span>
                </th>
                <th className="text-center">
                  <span>{t("common.status")}</span>
                </th>
                <th className="text-center">
                  <span>{t("admin.stores.table.qrCode")}</span>
                </th>
                <th className="text-center">
                  <span>{t("admin.stores.table.venueLink")}</span>
                </th>
                <th className="text-center">
                  <span>{t("admin.stores.table.venueAccessCode")}</span>
                </th>
                <th>
                  <span>{t("common.action")}</span>
                </th>
              </tr>
            </thead>
            <tbody className="table-body">
              {props.dataList.map((data) => {
                let address = data?.storeNumber + ", " + data?.street;
                if (data?.address) {
                  address = address + ", " + data?.address;
                }
                address = address + ", " + data?.city;
                return (
                  <tr key={data?.storeId || "na"}>
                    <td>{data?.storeName || t("common.na")}</td>
                    <td>{address || t("common.na")}</td>
                    <td>{data?.zone || t("common.na")}</td>
                    <td
                      className={`${!data?.stockQuantity || Number(data?.stockQuantity) <= 0
                        ? "color-red"
                        : ""
                        }`}
                    >
                      {data?.stockQuantity}
                    </td>
                    <td>{data?.lastActivity}</td>
                    <td className="text-center">
                      {data?.hideOnMap ? (
                        <span className="table-isinactive">{t("common.yes")}</span>
                      ) : (
                        <span className="table-isactive">{t("common.no")}</span>
                      )}
                    </td>

                    <td className="text-center">
                      {data?.isActivated ? (
                        <span className="table-isactive">{t("common.active")}</span>
                      ) : (
                        <span className="table-isinactive">{t("common.inactive")}</span>
                      )}
                    </td>
                    <td className="text-center">
                      <div
                        className="cursor"
                        onClick={() => props.viewQrData(data?.storeId)}
                      >
                        <i className="far fa-eye primary-color"></i>
                      </div>
                    </td>
                    <td className="text-center">
                      {props?.physicalCardEnabled ? (
                        (() => {
                          const venueUrl = props?.getVenueUrl
                            ? props.getVenueUrl(data?.storeId)
                            : "";
                          return (
                            <div className="d-flex flex-column align-items-center">
                              <div
                                className="cursor"
                                title={t("admin.stores.table.copyVenueLink")}
                                onClick={() => props?.copyVenueLink(data?.storeId)}
                              >
                                <i className="fas fa-link primary-color"></i>
                              </div>
                              {venueUrl && (
                                <a
                                  href={venueUrl}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="d-inline-block mt-1 primary-color text-truncate font-11"
                                  style={{ maxWidth: "180px" }}
                                  title={venueUrl}
                                >
                                  {venueUrl}
                                </a>
                              )}
                            </div>
                          );
                        })()
                      ) : (
                        <code>-</code>
                      )}
                    </td>
                    <td className="text-center nowrap">
                      {props?.physicalCardEnabled ? (
                        <>
                          <code>{data?.venueAccessCode || "-"}</code>
                          {data?.venueAccessCode && (
                            <span
                              className="ml-1 cursor"
                              title={t("admin.stores.table.regenerateVenueCode")}
                              onClick={() => props?.regenerateVenueCode(data?.storeId)}
                            >
                              <i className="fas fa-sync-alt primary-color"></i>
                            </span>
                          )}
                        </>
                      ) : (
                        <code>-</code>
                      )}
                    </td>
                    <td className="nowrap">
                      <span
                        className="mr-1 btn btn-own-admin primary-btn btn-sm-own table-action"
                        onClick={() => props?.manageStockData(data)}
                      >
                        {t("common.editStock")}
                      </span>{" "}
                      |{" "}
                      <span
                        className="mx-1 btn btn-own-admin primary-btn btn-sm-own table-action"
                        onClick={() => props.editData(data)}
                      >
                        {t("common.edit")}
                      </span>{" "}
                      |{" "}
                      <span
                        className="ml-1 btn btn-own-admin primary-btn btn-sm-own table-action"
                        onClick={() => props.deleteData(data)}
                      >
                        {t("common.delete")}
                      </span>

                      <span
                        className="ml-1 btn btn-own-admin primary-btn btn-sm-own table-action"
                        onClick={() => props?.toggleData(data)}
                      >

                        {!data?.isActivated ? t("common.activate") : t("common.deactivate")}

                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default StoresTable;
